import pickRandomOption from "./pickRandomOption";
import GameClient from "../../ui/GameClient";

/**
 * Artificial Player who chooses randomly its move
 */
export default function drunkPlayer(subj) {
  GameClient.register({
    subj: subj,
    notify: function(form) {
      var randomoption = pickRandomOption(form);
      GameClient.makeMove(subj, randomoption);
    }
  });
}
